import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";

const s1015SwiperThumbs = new Swiper('.s1015-swiper-thumbs', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 12,
    breakpoints: {
        375: {
            slidesPerView: 2,
        },
        425: {
            slidesPerView: 3,
        },
        640: {
            slidesPerView: 5,
        },
        767: {
            slidesPerView: 7,
        },
        1023: {
            slidesPerView: 9,
        },
        1440: {
            slidesPerView: 11,
        },
      }
});

const s1015Swiper = new Swiper('.s1015-swiper', {
    modules: [Thumbs, Navigation],
    loop: false,
    slidesPerView: 1,
    spaceBetween: 32,
    freeMode: true,
    watchSlidesProgress: true,
    thumbs: {
        swiper: s1015SwiperThumbs,
    },
    navigation: {
        nextEl: ".s1015-swiper .swiper-button-next",
        prevEl: ".s1015-swiper .swiper-button-prev",
    }
});